import React, { useState, useCallback } from 'react';
import { Select, Button } from 'antd';
import styles from './index.module.scss';

export const DEFAULT_COUNT_OPTIONS = Array.from({ length: 4 }, (_, index) => {
    const value = index + 1;
    return { value, label: `${value}张` };
});

const isValidCount = (count, countOptions) => (
    countOptions.some((option) => option.value === count)
);

const GenerateBar = ({
    onGenerate,
    loading,
    disabled = false,
    count: controlledCount,
    onCountChange,
    countOptions = DEFAULT_COUNT_OPTIONS,
    defaultCount = 4,
    leadingContent = null,
    trailingContent = null,
    buttonWidth = 150,
}) => {
    const normalizedDefaultCount = isValidCount(defaultCount, countOptions)
        ? defaultCount
        : (countOptions[0]?.value ?? 1);
    const [innerCount, setInnerCount] = useState(normalizedDefaultCount);
    const resolvedCount = controlledCount ?? innerCount;
    const count = isValidCount(resolvedCount, countOptions)
        ? resolvedCount
        : normalizedDefaultCount;

    const handleCountChange = useCallback((nextCount) => {
        const normalizedCount = isValidCount(nextCount, countOptions)
            ? nextCount
            : normalizedDefaultCount;

        if (typeof onCountChange === 'function') {
            onCountChange(normalizedCount);
            return;
        }

        setInnerCount(normalizedCount);
    }, [countOptions, normalizedDefaultCount, onCountChange]);

    const handleGenerate = useCallback(() => {
        onGenerate?.({ count });
    }, [count, onGenerate]);

    const handlePopupWheel = useCallback((event) => {
        event.stopPropagation();
    }, []);
    const isBlocked = disabled || loading;

    return (
        <div className={styles.wrapper}>
            <div className={styles.left}>
                {leadingContent ? (
                    <div className={styles.leading}>
                        {leadingContent}
                    </div>
                ) : null}
                <Select
                    className={styles.countSelect}
                    value={count}
                    onChange={handleCountChange}
                    options={countOptions}
                    disabled={isBlocked}
                    size="small"
                    variant="borderless"
                    popupMatchSelectWidth={false}
                    getPopupContainer={(triggerNode) => triggerNode?.parentElement || triggerNode}
                    popupRender={(menu) => (
                        <div onWheel={handlePopupWheel}>
                            {menu}
                        </div>
                    )}
                />
                {trailingContent ? (
                    <div className={styles.trailing}>
                        {trailingContent}
                    </div>
                ) : null}
            </div>
            <Button
                type="primary"
                className={styles.generateBtn}
                onClick={isBlocked ? undefined : handleGenerate}
                disabled={isBlocked}
                style={{ width: buttonWidth }}
            >
                {loading ? '生成中' : '生成'}
            </Button>
        </div>
    );
};

export default GenerateBar;
